export default __webpack_public_path__ + "static/media/oops.7e156ed0.png";